import React from "react";
import pipaanlogo from "../../assets/pipaanlogo.png";
import profileimg from "../../assets/profile.png";
import profile from "../../assets/images/icons/profile.png";
import Account from "../../assets/images/icons/account-setting.png";
import help from "../../assets/images/icons/helpandsupport.png";
import logout from "../../assets/images/icons/logout.png";
import notification from "../../assets/images/icons/notification.png";
import MarketplaceCartLink from "../common/MarketplaceCartLink";
import hamburger from "../../assets/images/icons/hamburger.png";
import hamburgerclose from "../../assets/images/icons/hamburgerclose.png";
import { useState } from "react";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


export default function LeftResponsivesidebar() {
   
    // ✅ Define state properly
    const [isOpen, setIsOpen] = useState(false);

   

    const [isPopupOpen, setIsPopupOpen] = useState(false); // 🔹 Popup state

    const openPopup = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    return (

                <>
                    <header className="flex items-center justify-between pb-8 lg:hidden">
                        {/* Logo */}
                        <div className="flex items-center space-x-3">
                            <img src={pipaanlogo} alt="Pipaan Logo" className="md:w-30 md:h-30 w-[75px] h-[60px]" />
                        </div>

                        {/* Icons: Profile & Notification */}
                        <div className="flex items-center space-x-4">
                            <div className="relative top-2">
                                <img src={notification} alt="Notification" className="ml-4 cursor-pointer" />
                            </div>
                            <MarketplaceCartLink />
                            <div className="profile-dashboard rounded-full overflow-hidden">
                                <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
                            </div>

                            {/* Animated Hamburger Menu */}
                            <button
                                className={`lg:hidden p-2 rounded-md transition-all duration-300 ${isOpen ? "relative Hamburger" : "relative top-auto right-auto"
                                    }`}
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <motion.div
                                    animate={{ rotate: isOpen ? 180 : 0 }} // Rotation effect
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="w-6 h-6"
                                >
                                    <img
                                        src={isOpen ? hamburgerclose : hamburger}
                                        alt="Menu Toggle"
                                        className="w-6 h-6 object-cover transition-all duration-300"
                                    />
                                </motion.div>
                            </button>
                        </div>
                    </header>

                    {/* Sidebar Navigation */}
                    <aside
                        className={`hamburg-popup fixed top-0 left-0 w-64 backdrop-blur m-5 p-6 h-full shadow-lg transition-transform ${isOpen ? "translate-x-0" : "-translate-x-full"
                            } lg:hidden`}
                    >
                        <div className="pop border-[#C5C5C5]">
                            {/* Navigation Links */}
                            <nav className="space-y-4 my-8">
                                <div className="space-x-2 mobile-hamburg">
                                    <div className="search-fixed-menu">
                                        <div className="text-center py-8">
                                            <div className="profile-dashboard rounded-full overflow-hidden">
                                                <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
                                            </div>
                                            <p className="font-semibold">Proveen Krishnamoorthy</p>
                                            <p className="text-sm text-gray-500">@proveen_sky</p>
                                        </div>
                                    </div>
                                </div>
                                <a href="myprofile" className="aside-menu aside-menu-sm hover:bg-gray-200 rounded-xl">
                                    <img src={profile} alt="Profile Icon" />
                                    <span>Profile</span>
                                </a>
                                <a href="#" className="aside-menu aside-menu-sm hover:bg-gray-200 rounded-xl">
                                    <img src={Account} alt="Account Icon" />
                                    <span>Account Settings</span>
                                </a>
                                <a href="#" className="aside-menu aside-menu-sm hover:bg-gray-200 rounded-xl">
                                    <img src={help} alt="Help Icon" />
                                    <span>Help & Support</span>
                                </a>
                                
                                 <a href="#" className="aside-menu aside-menu-sm hover:bg-gray-200 rounded-xl">
                                    <img src={help} alt="Help Icon" />
                                    <span>About us</span>
                                </a>
                                <a href="logout" className="aside-menu aside-menu-sm hover:bg-red-200 rounded-xl text-red-600">
                                    <img src={logout} alt="Logout Icon" />
                                    <span>Logout</span>
                                </a>
                            </nav>
                        </div>
                    </aside>
                </>
    );
}
